<!-- 添加评论 -->
<template>
  <!-- 发表讨论 -->
  <div class="mentee-zoom-add-dicuss">
    <div>
      <div>
        <discuss-add title="Add discussion"
                     v-model="content"
                     :avatar="userAvatar"
                     ref="addDiscuss">
          <div style="display:inline-block;"
               :class="{'zlr-cover':(!content || !data.billId)}">
            <Button class="zlr-btn-primary"
                    @click="handleSend"
                    :loading="isSub">Send</Button>
          </div>
        </discuss-add>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { createComments } from '@/api/comments/'
// components
import DiscussAdd from '_c/discuss-add/discuss-add'
import { mapState } from 'vuex'
// constant
import { promptInput, addCommentSuc } from '@/constant'
export default {
  name: '',
  props: ['data'],
  components: {
    DiscussAdd
  },
  data () {
    return {
      isSub: false,
      content: ''
    }
  },
  computed: {
    ...mapState({
      userAvatar (state) {
        return state.user.userAvatar
      }
    })
  },
  mounted () { },
  methods: {
    // 发送讨论
    handleSend () {
      if (!this.content) {
        this.$zlr_message(promptInput, 'error')
        return false
      }
      let data = {
        ...this.data,
        content: this.content
      }
      this.isSub = true
      createComments(data).then(res => {
        this.$zlr_message(addCommentSuc, 'success')
        this.content = ''
        this.$refs['addDiscuss'].resetHtml()
        this.$emit('on-success')
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.isSub = false
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
